import Modal from '../../common/Modal'
import PropTypes from 'prop-types'

import SubmitButton from '../../common/buttons/SubmitButton'
import { ReactComponent as WarningIcon } from '../../../assets/images/common/icons/warning-icon.svg'

import styles from './DeletePairingsModal.module.scss'
import classNames from 'classnames'

const DeletePairingsModal = ({ showModal, closeModal, onSubmit }) => (
  <Modal
    isOpen={showModal}
    onClose={closeModal}
    className={styles.deletePairingsModal}
    autoFocus
  >
    <div className={classNames('d-flex flex-column align-items-center', styles.modalContainer)}>
      <div className='d-flex justify-content-center align-items-center'>
        <WarningIcon/>
      </div>
      <div className={styles.modalContent}>
        <span className={styles.title}>Delete All Pairings</span>
        <p className='my-3'>Are you sure you want to delete all Pairings?<br/>This will reset your RSVP to live.</p>
      </div>
      <div className='w-100 pull-bottom'>
        <SubmitButton
          onClick={onSubmit}
          buttonMessage='Delete Pairings'
          buttonColor='orange-button'
        />
        <SubmitButton
          onClick={closeModal}
          buttonMessage='Exit'
          buttonColor='navy-button'
        />
      </div>
    </div>
  </Modal>
)

DeletePairingsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default DeletePairingsModal
